import { useEffect, useState } from "react";

export const MOBILE_BREAKPOINT = 768;

/**
 * Returns true when the viewport is mobile (≤768px).
 * Use this hook anywhere a component needs to know the current breakpoint.
 * The value updates reactively on window resize.
 *
 * Usage:
 *   const isMobile = useBreakpoint();
 */
const useBreakpoint = (): boolean => {
  const query = `(max-width: ${MOBILE_BREAKPOINT}px)`;
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  return isMobile;
};

export default useBreakpoint;
